import { useInfiniteQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/client";
import { ENDPOINTS } from "@/api/endpoints";
import { PaginatedResponse, ScheduledJob } from "@/types/common.types";

type ScheduledJobResponse = PaginatedResponse<ScheduledJob>;

interface GetScheduledJobsParams {
  page?: number;
  size?: number;
  searchParam?: string;
}

const getScheduledJobs = async ({
  pageParam = 0,
  size = 50,
  searchParam,
}: GetScheduledJobsParams & {
  pageParam?: number;
}): Promise<ScheduledJobResponse> => {
  return apiClient
    .get(ENDPOINTS.GET_SCHEDULED_JOBS(pageParam, size, searchParam))
    .json<ScheduledJobResponse>();
};

export const useGetScheduledJobsQuery = (
  size: number = 50,
  searchParam?: string
) => {
  return useInfiniteQuery({
    queryKey: ["scheduledJobs", size, searchParam] as const,
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      getScheduledJobs({ pageParam: pageParam as number, size, searchParam }),
    getNextPageParam: (lastPage) => {
      if (lastPage.page >= lastPage.totalPages - 1) {
        return undefined;
      }
      return lastPage.page + 1;
    },
    gcTime: Infinity,
    staleTime: Infinity,
  });
};
